let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dTwLk")).then(() => parcelRequire('4dHKB'));